"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Preview/components/ContentTable.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    Switch_template = require("../../../../components/Switch/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Switch_tag = marko_loadTag(Switch_template),
    Locale_template = require("../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_attrs0 = {
        "class": "px-1 py-50"
      },
    marko_attrs1 = {
        "class": "list-unstyled m-0"
      },
    marko_attrs2 = {
        "class": "px-3"
      },
    marko_attrs3 = {
        "class": "py-50"
      },
    marko_attrs4 = {
        "class": "text-muted"
      },
    marko_attrs5 = {
        "class": "pl-4"
      },
    marko_attrs6 = {
        "class": "text-muted"
      },
    marko_attrs7 = {
        "class": "font-small-3"
      },
    marko_attrs8 = {
        "class": "content-table"
      },
    marko_attrs9 = {
        "class": "list-unstyled m-0"
      };

function render(input, out, __component, component, state) {
  var data = input;

  function macro_Looper(out, { link, list, singleLi }) {
    var $for$0 = 0;

    marko_forOf(list, function(outline, index) {
      const newLink = link ? link +'.'+ index : '#'+ index

      var $keyScope$0 = "[" + (($for$0++) + "]");

      Switch_tag({
          by: outline.type,
          case: [
              {
                  is: "module",
                  renderBody: function(out) {
                    marko_dynamicTag(out, macro_Module, function() {
                      return {
                          details: outline,
                          link: newLink
                        };
                    }, null, null, null, __component, "15" + $keyScope$0);
                  }
                }
            ],
          default: {
              renderBody: function(out) {
                if (singleLi) {
                  out.be("div", marko_attrs0, "2" + $keyScope$0, component);

                  out.be("ul", marko_attrs1, "@" + newLink, component);

                  marko_dynamicTag(out, macro_Line, function() {
                    return {
                        details: outline,
                        link: newLink
                      };
                  }, null, null, null, __component, "16" + $keyScope$0);

                  out.ee();

                  out.ee();
                } else {
                  marko_dynamicTag(out, macro_Line, function() {
                    return {
                        details: outline,
                        link: newLink
                      };
                  }, null, null, null, __component, "17" + $keyScope$0);
                }
              }
            }
        }, out, __component, newLink);
    });
  }

  function macro_Module(out, { link, details }) {
    out.be("li", marko_attrs2, "@" + link, component);

    out.be("div", marko_attrs3, "3", component);

    Locale_tag({
        text: details.title,
        class: "font-medium-2"
      }, out, __component, "4");

    out.be("p", marko_attrs4, "5", component);

    Locale_tag({
        text: details.subtitle
      }, out, __component, "6");

    out.ee();

    out.ee();

    out.be("div", null, "7", component);

    out.be("ol", null, "8", component);

    marko_dynamicTag(out, macro_Looper, function() {
      return {
          list: details.outlines,
          link: link
        };
    }, null, null, null, __component, "18");

    out.ee();

    out.ee();

    out.ee();
  }

  function macro_Line(out, { link, details, duration }) {
    out.be("li", marko_attrs5, "@" + link, component);

    Locale_tag({
        text: details.title,
        class: "font-medium-1"
      }, out, __component, "9");

    if (duration) {
      out.e("span", marko_attrs7, "10", component, 1)
        .t(formatTime(duration), component);
    }

    out.be("p", marko_attrs6, "11", component);

    Locale_tag({
        text: details.subtitle
      }, out, __component, "12");

    out.ee();

    out.ee();
  }

  if (Array.isArray(input.list) && input.list.length) {
    out.be("div", marko_attrs8, "13", component);

    out.be("ul", marko_attrs9, "14", component);

    marko_dynamicTag(out, macro_Looper, function() {
      return {
          list: input.list,
          singleLi: true
        };
    }, null, null, null, __component, "19");

    out.ee();

    out.ee();
  }
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
